import CopyLandingLoader from './versions/0.0.1/CopyLandingLoader';

export default CopyLandingLoader;
